<template>
  <div class="expand-able-text" @click.stop="contract">
    <div class="title">
      <i :class="'iconfont' + ' ' + icon + ' ' + color"></i>
      <p>{{ title }}</p>
    </div>
    <div v-html="expand ? text2.substring(0, 100) + '...' : text2"></div>
    <p class="tool" v-if="expand" @click.stop="expand = !expand">全部</p>
    <p class="tool" v-if="!expand && total > 100" @click.stop="expand = !expand">收起</p>
  </div>
</template>
<style lang="scss">
  @import "../assets/scss/functions";
  .expand-able-text {
    padding: pxToRem(20px) 0;
    border-bottom: pxToRem(1px) solid #f8f8f8;
    margin-bottom: pxToRem(20px);

    &:last-child{
      border-bottom: none;
    }
  }

  .title {
    display: flex;
    align-items: center;
    margin-bottom: pxToRem(25px);

    i {
      margin-right: pxToRem(10px);
    }
  }

  p.tool {
    color: #007aff;
    text-align: right;
  }

  .red {
    color: #EE817D;
  }

  .orange {
    color: #ffcb80;
  }

  .pink {
    color: #ff5c5e;
  }

  .blue {
    color: #2e81fb;
  }

  .gray {
    color: #d3c4ed;
  }

  .purple {
    color: #9A75B2;
  }

  .green {
    color: #6CBC5A;
  }
</style>
<script>
export default {
  props: ['text', 'icon', 'title', 'color'],
  data: function () {
    return {
      expand: true,
      total: 0
    }
  },
  computed: {
    text2: function () {
      this.contract()
      return this.text
    }
  },
  methods: {
    contract () {
      if (this.text.length > 100) {
        this.expand = true
      } else {
        this.expand = false
      }
    }
  },
  watch: {
    text () {
      this.total = this.text.length
    }
  },
  mounted () {
    this.expand = this.text.length > 100
    this.total = this.text.length
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ExpandableText.vue